// Univerzální CSS tooltip directive s vlastní konvencí
export const vTooltip = {
  mounted(el, binding) {
    // IGNOROVAT pokud má Bootstrap tooltip atributy
    if (el.hasAttribute('data-bs-toggle') && el.getAttribute('data-bs-toggle') === 'tooltip') {
      return
    }

    setupTooltip(el, binding.value || el.getAttribute('title'))
  },
  updated(el, binding) {
    if (el.hasAttribute('data-bs-toggle') && el.getAttribute('data-bs-toggle') === 'tooltip') {
      return
    }

    // Aktualizuj obsah existujícího tooltipu
    if (el._tooltipText && binding.value) {
      el._tooltipText = binding.value

      // Pokud je tooltip aktuálně zobrazený, aktualizuj jeho obsah
      const activeTooltip = document.querySelector(`.css-tooltip[data-target-id="${el._tooltipId}"]`)
      if (activeTooltip) {
        activeTooltip.textContent = binding.value
        updateTooltipSizeClass(activeTooltip)
      }
    }
  },
  unmounted(el) {
    // Odstranění tooltipu z DOM
    if (el._tooltipId) {
      const tooltip = document.querySelector(`.css-tooltip[data-target-id="${el._tooltipId}"]`)
      if (tooltip) {
        tooltip.remove()
      }
    }

    // Odstranění event listenerů
    if (el._showTooltip) {
      el.removeEventListener('mouseenter', el._showTooltip)
      el.removeEventListener('mouseleave', el._hideTooltip)
    }
    if (el._showTooltipOnFocus) {
      el.removeEventListener('focus', el._showTooltipOnFocus)
      el.removeEventListener('blur', el._hideTooltipOnFocus)
    }
  }
}

function updateTooltipSizeClass(tooltip) {
  // Odstraň existující size třídy
  tooltip.classList.remove('tooltip-short', 'tooltip-sm', 'tooltip-lg')
}

function setupTooltip(el, tooltipText) {
  if (!tooltipText) {
    return
  }

  // Vytvoř unikátní ID pro tento tooltip
  el._tooltipId = `tooltip_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
  el._tooltipText = tooltipText

  // Získej nastavení z atributů
  const placement = el.getAttribute('tooltip-position') || el.getAttribute('data-tooltip-position') || 'top'
  const trigger = el.getAttribute('tooltip-trigger') || el.getAttribute('data-tooltip-trigger') || 'hover'

  let showTimeout = null
  let hideTimeout = null

  // Funkce pro zobrazení tooltipu
  const showTooltip = () => {

    // Kontrola, zda element stále existuje v DOM
    if (!el || !el.isConnected || !document.body.contains(el)) {
      return
    }

    if (el._hideTimeout) {
      clearTimeout(el._hideTimeout)
    }

    let tooltip = document.querySelector(`.css-tooltip[data-target-id="${el._tooltipId}"]`)

    if (!tooltip) {
      tooltip = document.createElement('div')
      tooltip.className = 'css-tooltip tooltip-measuring'
      tooltip.innerHTML = el._tooltipText
      tooltip.setAttribute('data-target-id', el._tooltipId)

      updateTooltipSizeClass(tooltip)

      const arrow = document.createElement('div')
      arrow.className = 'css-tooltip-arrow'
      tooltip.appendChild(arrow)
      document.body.appendChild(tooltip)

      // ✅ Použij requestAnimationFrame pro Safari
      requestAnimationFrame(() => {
        positionTooltip(tooltip, el, placement)
        requestAnimationFrame(() => {
        })
      })
    } else {
      console.log('tooltip already exists')
      positionTooltip(tooltip, el, placement)
    }
  }

  // Funkce pro skrytí tooltipu
  const hideTooltip = () => {
    clearTimeout(showTimeout)

    hideTimeout = setTimeout(() => {
      const tooltip = document.querySelector(`.css-tooltip[data-target-id="${el._tooltipId}"]`)
      if (tooltip) {
        tooltip.style.visibility = 'hidden'
        tooltip.style.opacity = '0'

        // Odstraň tooltip z DOM po animaci
        setTimeout(() => {
          if (tooltip.parentNode) {
            tooltip.remove()
          }
        }, 300) // čekej na dokončení transition
      }
    }, 100) // malé zpoždění před skrytím
  }

  // Nastavení event listenerů podle trigger typu
  if (trigger === 'focus') {
    el._showTooltipOnFocus = showTooltip
    el._hideTooltipOnFocus = hideTooltip

    el.addEventListener('focus', el._showTooltipOnFocus)
    el.addEventListener('blur', el._hideTooltipOnFocus)
  } else {
    // defaultní hover trigger
    el._showTooltip = () => {
      clearTimeout(hideTimeout)
      showTimeout = setTimeout(showTooltip, 500) // malé zpoždění před zobrazením
    }

    el._hideTooltip = hideTooltip

    el.addEventListener('mouseenter', el._showTooltip)
    el.addEventListener('mouseleave', el._hideTooltip)
  }
}

function positionTooltip(tooltip, targetEl, preferredPlacement) {
  // Získej pozici cílového elementu relativně k viewportu
  const targetRect = targetEl.getBoundingClientRect()

  // Získej scroll pozice
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop

  // Základní pozice relativně k dokumentu
  const targetLeft = targetRect.left + scrollLeft
  const targetTop = targetRect.top + scrollTop
  const targetWidth = targetRect.width
  const targetHeight = targetRect.height

  tooltip.classList.add('tooltip-measuring')
  const tooltipRect = tooltip.getBoundingClientRect()
  tooltip.style.inlineSize = `${tooltipRect.width}px`  // fix for safari
  const tooltipWidth = tooltipRect.width
  const tooltipHeight = tooltipRect.height

  tooltip.classList.remove('tooltip-measuring')


  // Získej rozměry viewportu
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  const offset = 10
  const arrowSize = 5

  // 🎯 INTELIGENTNÍ VÝBĚR POZICE s fallback mechanismem
  const actualPlacement = getBestPlacement(
    preferredPlacement,
    targetRect,
    tooltipWidth,
    tooltipHeight,
    viewportWidth,
    viewportHeight,
    offset
  )

  const arrow = tooltip.querySelector('.css-tooltip-arrow')
  let left, top

  switch (actualPlacement) {
    case 'top':
      left = targetLeft + targetWidth / 2 - tooltipWidth / 2
      top = targetTop - tooltipHeight - offset

      // Šipka dolů
      if (arrow) {
        arrow.style.cssText = `
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -${arrowSize}px;
          border-width: ${arrowSize}px;
          border-style: solid;
          border-color: #333 transparent transparent transparent;
        `
      }
      break

    case 'bottom':
      left = targetLeft + targetWidth / 2 - tooltipWidth / 2
      top = targetTop + targetHeight + offset

      // Šipka nahoru
      if (arrow) {
        arrow.style.cssText = `
          position: absolute;
          bottom: 100%;
          left: 50%;
          margin-left: -${arrowSize}px;
          border-width: ${arrowSize}px;
          border-style: solid;
          border-color: transparent transparent #333 transparent;
        `
      }
      break

    case 'left':
      left = targetLeft - tooltipWidth - offset
      top = targetTop + targetHeight / 2 - tooltipHeight / 2

      // Šipka vpravo
      if (arrow) {
        arrow.style.cssText = `
          position: absolute;
          top: 50%;
          left: 100%;
          margin-top: -${arrowSize}px;
          border-width: ${arrowSize}px;
          border-style: solid;
          border-color: transparent transparent transparent #333;
        `
      }
      break

    case 'right':
      left = targetLeft + targetWidth + offset
      top = targetTop + targetHeight / 2 - tooltipHeight / 2

      // Šipka vlevo
      if (arrow) {
        arrow.style.cssText = `
          position: absolute;
          top: 50%;
          right: 100%;
          margin-top: -${arrowSize}px;
          border-width: ${arrowSize}px;
          border-style: solid;
          border-color: transparent #333 transparent transparent;
        `
      }
      break
  }

  // Jemné doladění pozice pro případ, že by tooltip stále vyčuhoval
  left = Math.max(10, Math.min(left, viewportWidth + scrollLeft - tooltipWidth - 10))
  top = Math.max(10 + scrollTop, Math.min(top, viewportHeight + scrollTop - tooltipHeight - 10))

  // Aplikuj finální pozici
  tooltip.style.left = `${left}px`
  tooltip.style.top = `${top}px`
}

/**
 * 🧠 Inteligentní výběr nejlepší pozice pro tooltip
 * Zkouší preferovanou pozici, a pokud nevyhovuje, hledá nejlepší alternativu
 */
function getBestPlacement(preferredPlacement, targetRect, tooltipWidth, tooltipHeight, viewportWidth, viewportHeight, offset) {
  const spaceTop = targetRect.top
  const spaceBottom = viewportHeight - targetRect.bottom
  const spaceLeft = targetRect.left
  const spaceRight = viewportWidth - targetRect.right

  const requiredWidth = tooltipWidth + offset * 2
  const requiredHeight = tooltipHeight + offset

  // Kontrola, zda preferovaná pozice vyhovuje
  const placements = {
    top: spaceTop >= requiredHeight,
    bottom: spaceBottom >= requiredHeight,
    left: spaceLeft >= requiredWidth,
    right: spaceRight >= requiredWidth
  }

  // Pokud preferovaná pozice vyhovuje, použij ji
  if (placements[preferredPlacement]) {
    return preferredPlacement
  }

  // 🔄 FLIP logika - najdi nejlepší alternativu
  const flipMap = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
  }

  // Zkus opačnou stranu
  const flippedPlacement = flipMap[preferredPlacement]
  if (placements[flippedPlacement]) {
    return flippedPlacement
  }

  // Pokud ani opačná strana nevyhovuje, najdi stranu s nejvíce místem
  const spaces = [
    { placement: 'top', space: spaceTop, fits: placements.top },
    { placement: 'bottom', space: spaceBottom, fits: placements.bottom },
    { placement: 'left', space: spaceLeft, fits: placements.left },
    { placement: 'right', space: spaceRight, fits: placements.right }
  ]

  // Nejprve zkus najít pozici, která se vejde
  const fittingPlacements = spaces.filter(s => s.fits)
  if (fittingPlacements.length > 0) {
    return fittingPlacements.sort((a, b) => b.space - a.space)[0].placement
  }

  // Pokud se tooltip nevejde nikam, vyber pozici s nejvíce místem
  return spaces.sort((a, b) => b.space - a.space)[0].placement
}